var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st1 {\n        fill: #eb1700;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16,2c-7.7,0-14,6.3-14,14s6.3,14,14,14,14-6.3,14-14S23.7,2,16,2ZM13.1,10.2l-1.1.7h0v10.2l1.1.7h0l9.5-5h0v-1.5l-9.5-5.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.1,10.2l-1.1.7h0v10.2l1.1.7h0l9.5-5h0v-1.5l-9.5-5.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.f388bc0c280bbc752318c459b9a2a63a.svg";
export { ForwardRef as ReactComponent };